import React from 'react';
import clsx from 'clsx';
import fontWeights from '../../Typography/shared/fontWeights/fontWeights';
import Depot from '../../_shared/depot';
import Spinner from '../../Spinner';
import * as styles from './style.module.css';
import typeSizes from '../../Typography/shared/typeSizes/typeSizes';
const ButtonText = ({ text, size, loading }) => {
    const textStylesMapping = {
        small: typeSizes.body,
        medium: typeSizes.large,
        large: styles.customTitle2,
        xLarge: typeSizes.title2,
    };
    const buttonTextStyles = clsx(styles.text, { [styles.loading]: loading }, textStylesMapping[size], fontWeights.bold);
    return React.createElement("span", { className: buttonTextStyles }, text);
};
const IconSlot = ({ icon: PassedIcon, alignIcon, fullWidth, loading, position, }) => {
    const iconStyles = styles.icon;
    const iconPlaceholderStyles = styles.iconPlaceholder;
    const Icon = React.createElement(PassedIcon, { className: iconStyles, size: 24 });
    const IconPlaceholder = React.createElement("span", { className: iconPlaceholderStyles });
    if (alignIcon === position) {
        return loading ? IconPlaceholder : Icon;
    }
    if (fullWidth) {
        return IconPlaceholder;
    }
    return null;
};
const SpinnerWrapper = ({ buttonType, disabled }) => {
    const inverted = !disabled &&
        ['primary', 'secondary1', 'secondary3', 'destructive'].includes(buttonType);
    return (React.createElement(Spinner, { testId: "spinner", inverted: inverted, className: clsx(styles.spinner) }));
};
const ButtonPrimitiveWithoutRef = ({ alignIcon = 'leading', loading = false, fullWidth = false, size = 'medium', buttonType = 'primary', disabled = false, icon, text, }) => {
    return (React.createElement(React.Fragment, null,
        icon && alignIcon && (React.createElement(IconSlot, { icon: icon, alignIcon: alignIcon, fullWidth: fullWidth, loading: loading, position: "leading" })),
        React.createElement(ButtonText, { text: text, size: size, loading: loading }),
        loading && (React.createElement(SpinnerWrapper, { buttonType: buttonType, disabled: disabled })),
        icon && alignIcon && (React.createElement(IconSlot, { icon: icon, alignIcon: alignIcon, fullWidth: fullWidth, loading: loading, position: "trailing" }))));
};
const ButtonPrimitive = Depot.withRef(ButtonPrimitiveWithoutRef);
ButtonPrimitive.displayName = 'ButtonPrimitive';
export default ButtonPrimitive;
//# sourceMappingURL=ButtonPrimitive.js.map